import { Navigate, useLocation } from "react-router-dom";
import { usePromoAuth } from "../context/AuthContext";

export default function PromoProtectedRoute({ children }) {
  const { account, initializing } = usePromoAuth();
  const location = useLocation();
  if (initializing) {
    return (
      <div className="min-h-screen flex items-center justify-center promo-bg-main">
        <div className="flex flex-col items-center gap-3">
          <div className="p-brand-mark p-pulse-gold">M88</div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-white/40">Loading premium panel…</div>
        </div>
      </div>
    );
  }
  if (!account) {
    return <Navigate to="/promo/login" state={{ from: location.pathname }} replace />;
  }
  if (account.must_change_password && location.pathname !== "/promo/change-password") {
    return <Navigate to="/promo/change-password" replace />;
  }
  return children;
}
